// ============================================
// PinkLemon Crochet - Enhanced JavaScript
// With cute animals, customizer & interactions
// ============================================

document.addEventListener('DOMContentLoaded', function() {
    
    // ============================================
    // Cart Panel Toggle
    // ============================================
    const cartToggle = document.getElementById('cartToggle');
    const cartPanel = document.getElementById('cartPanel');
    const cartOverlay = document.getElementById('cartOverlay');
    const cartClose = document.getElementById('cartClose');
    const browseShopBtn = document.getElementById('browseShopBtn');
    
    function openCart() {
        cartPanel.classList.add('active');
        cartOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
    }
    
    function closeCart() {
        cartPanel.classList.remove('active');
        cartOverlay.classList.remove('active');
        document.body.style.overflow = '';
    }
    
    if (cartToggle) {
        cartToggle.addEventListener('click', (e) => {
            e.preventDefault();
            openCart();
        });
    }
    
    if (cartClose) {
        cartClose.addEventListener('click', closeCart);
    }
    
    if (cartOverlay) {
        cartOverlay.addEventListener('click', closeCart);
    }
    
    if (browseShopBtn) {
        browseShopBtn.addEventListener('click', closeCart);
    }

    // Mobile floating cart button
    const mobileCartFab = document.getElementById('mobileCartFab');
    if (mobileCartFab) {
        mobileCartFab.addEventListener('click', openCart);
    }
    
    // ============================================
    // Portfolio Show More/Less Toggle
    // ============================================
    const showMoreBtn = document.getElementById('showMoreBtn');
    const portfolioGrid = document.getElementById('portfolioGrid');
    
    if (showMoreBtn && portfolioGrid) {
        showMoreBtn.addEventListener('click', () => {
            const isExpanded = portfolioGrid.classList.toggle('expanded');
            const showMoreText = showMoreBtn.querySelector('.show-more-text');
            const showLessText = showMoreBtn.querySelector('.show-less-text');
            
            if (isExpanded) {
                showMoreText.style.display = 'none';
                showLessText.style.display = 'inline';
            } else {
                showMoreText.style.display = 'inline';
                showLessText.style.display = 'none';
                // Scroll back to portfolio section
                document.getElementById('portfolio').scrollIntoView({ behavior: 'smooth' });
            }
        });
    }
    
    // ============================================
    // Reviews Show More/Less Toggle
    // ============================================
    const reviewsToggle = document.getElementById('reviewsToggle');
    const reviewsGrid = document.querySelector('.reviews-grid');
    const reviewsToggleContainer = document.querySelector('.reviews-toggle-container');

    function syncReviewGridState() {
        if (!reviewsGrid) return;

        const cards = Array.from(reviewsGrid.querySelectorAll('.review-card'));
        cards.forEach((card, index) => {
            card.classList.toggle('hidden-review', index >= 3);
        });

        if (reviewsToggleContainer) {
            reviewsToggleContainer.style.display = cards.length > 3 ? 'block' : 'none';
        }

        if (cards.length <= 3 && reviewsToggle) {
            reviewsGrid.classList.remove('show-all');
            const showMoreText = reviewsToggle.querySelector('.show-more-text');
            const showLessText = reviewsToggle.querySelector('.show-less-text');
            if (showMoreText) showMoreText.style.display = 'inline';
            if (showLessText) showLessText.style.display = 'none';
        }
    }

    function buildReviewStars(rating) {
        const fullStars = '★★★★★'.slice(0, rating);
        const emptyStars = '☆☆☆☆☆'.slice(0, 5 - rating);
        return fullStars + emptyStars;
    }

    function formatReviewDate(value) {
        if (!value) return '';

        const parsed = new Date(value);
        if (Number.isNaN(parsed.getTime())) return '';

        return new Intl.DateTimeFormat('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        }).format(parsed);
    }

    function createDynamicReviewCard(review) {
        const card = document.createElement('div');
        card.className = 'review-card';
        card.dataset.dynamicReview = 'true';

        const product = document.createElement('div');
        product.className = 'review-product';
        product.textContent = review.verifiedPurchase
            ? `${review.product} • Verified Purchase`
            : review.product;

        const stars = document.createElement('div');
        stars.className = 'review-stars';
        stars.textContent = buildReviewStars(Math.max(1, Math.min(5, Number(review.rating) || 5)));

        const text = document.createElement('p');
        text.className = 'review-text';
        text.textContent = `"${review.text}"`;

        const reviewer = document.createElement('div');
        reviewer.className = 'reviewer';

        const avatar = document.createElement('div');
        avatar.className = 'reviewer-avatar';
        avatar.textContent = (review.name || 'P').trim().charAt(0).toUpperCase() || 'P';

        const reviewerInfo = document.createElement('div');
        reviewerInfo.className = 'reviewer-info';

        const reviewerName = document.createElement('span');
        reviewerName.className = 'reviewer-name';
        reviewerName.textContent = review.name || 'Lovely Customer';

        const reviewerDate = document.createElement('span');
        reviewerDate.className = 'review-date';
        reviewerDate.textContent = formatReviewDate(review.updatedAt || review.createdAt);

        reviewerInfo.appendChild(reviewerName);
        reviewerInfo.appendChild(reviewerDate);
        reviewer.appendChild(avatar);
        reviewer.appendChild(reviewerInfo);

        card.appendChild(product);
        card.appendChild(stars);
        card.appendChild(text);
        card.appendChild(reviewer);

        return card;
    }

    async function loadDynamicReviews() {
        if (!reviewsGrid) return;

        try {
            const response = await fetch(((window.PINKLEMON && window.PINKLEMON.api_base) || '') + '/api/get-reviews');
            if (!response.ok) {
                throw new Error('Could not load reviews');
            }

            const data = await response.json();
            const reviews = Array.isArray(data.reviews) ? data.reviews : [];
            if (reviews.length === 0) {
                syncReviewGridState();
                return;
            }

            reviewsGrid.querySelectorAll('[data-dynamic-review="true"]').forEach((card) => card.remove());

            const fragment = document.createDocumentFragment();
            reviews.forEach((review) => {
                fragment.appendChild(createDynamicReviewCard(review));
            });

            reviewsGrid.prepend(fragment);
            syncReviewGridState();
        } catch (error) {
            console.error('Review loading error:', error);
            syncReviewGridState();
        }
    }
    
    if (reviewsToggle && reviewsGrid) {
        reviewsToggle.addEventListener('click', () => {
            const isExpanded = reviewsGrid.classList.toggle('show-all');
            const showMoreText = reviewsToggle.querySelector('.show-more-text');
            const showLessText = reviewsToggle.querySelector('.show-less-text');
            
            if (isExpanded) {
                showMoreText.style.display = 'none';
                showLessText.style.display = 'inline';
            } else {
                showMoreText.style.display = 'inline';
                showLessText.style.display = 'none';
                // Scroll back to reviews section
                document.getElementById('reviews').scrollIntoView({ behavior: 'smooth' });
            }
        });
    }

    syncReviewGridState();
    loadDynamicReviews();
    
    // ============================================
    // Navbar State
    // ============================================
    const navbar = document.querySelector('.navbar');
    
    if (navbar) {
        navbar.classList.remove('scrolled');
    }
    
    // ============================================
    // Custom Cursor
    // ============================================
    const cursor = document.querySelector('.custom-cursor');
    const cursorTrail = document.querySelector('.cursor-trail');
    let mouseX = 0, mouseY = 0;
    let trailX = 0, trailY = 0;
    
    if (cursor && cursorTrail) {
        document.addEventListener('mousemove', (e) => {
            mouseX = e.clientX;
            mouseY = e.clientY;
            cursor.style.left = mouseX + 'px';
            cursor.style.top = mouseY + 'px';
        });
        
        // Smooth trail following
        function animateTrail() {
            trailX += (mouseX - trailX) * 0.15;
            trailY += (mouseY - trailY) * 0.15;
            cursorTrail.style.left = trailX + 'px';
            cursorTrail.style.top = trailY + 'px';
            requestAnimationFrame(animateTrail);
        }
        animateTrail();
        
        // Cursor states
        document.addEventListener('mousedown', () => cursor.classList.add('clicking'));
        document.addEventListener('mouseup', () => cursor.classList.remove('clicking'));
        
        // Hover state for interactive elements
        const hoverElements = document.querySelectorAll('a, button, .product-card, .pattern-card, .gallery-item, .nav-link');
        hoverElements.forEach(el => {
            el.addEventListener('mouseenter', () => cursor.classList.add('hovering'));
            el.addEventListener('mouseleave', () => cursor.classList.remove('hovering'));
        });
    }
    
    // ============================================
    // Click Effects - White Sparkles
    // ============================================
    const clickEffects = document.getElementById('clickEffects');
    const clickEmojis = ['✦', '✧', '✴', '✵', '✶', '✷', '✸', '❋'];
    
    document.addEventListener('click', (e) => {
        if (!clickEffects) return;
        for (let i = 0; i < 5; i++) {
            setTimeout(() => {
                const sparkle = document.createElement('div');
                sparkle.className = 'click-heart';
                sparkle.textContent = clickEmojis[Math.floor(Math.random() * clickEmojis.length)];
                sparkle.style.left = (e.clientX + (Math.random() - 0.5) * 60) + 'px';
                sparkle.style.top = (e.clientY + (Math.random() - 0.5) * 60) + 'px';
                sparkle.style.color = 'white';
                sparkle.style.textShadow = '0 0 10px rgba(255,255,255,0.8), 0 0 20px rgba(212,118,140,0.5)';
                clickEffects.appendChild(sparkle);
                
                setTimeout(() => sparkle.remove(), 1000);
            }, i * 80);
        }
    });
    
    // ============================================
    // Theme Customizer
    // ============================================
    const customizerToggle = document.getElementById('customizerToggle');
    const customizerPanel = document.getElementById('customizerPanel');
    const colorButtons = document.querySelectorAll('.color-btn');
    const animalsToggle = document.getElementById('animalsToggle');
    const sparkleToggle = document.getElementById('sparkleToggle');
    const bubbleToggle = document.getElementById('bubbleToggle');
    const floatingAnimals = document.getElementById('floatingAnimals');
    
    // Toggle customizer panel
    if (customizerToggle && customizerPanel) {
        customizerToggle.addEventListener('click', () => {
            customizerPanel.classList.toggle('open');
        });
        
        // Close panel when clicking outside
        document.addEventListener('click', (e) => {
            if (!customizerPanel.contains(e.target) && !customizerToggle.contains(e.target)) {
                customizerPanel.classList.remove('open');
            }
        });
    }
    
    // Color theme switching
    colorButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            colorButtons.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            
            const theme = btn.getAttribute('data-theme');
            document.body.className = '';
            if (theme !== 'pink') {
                document.body.classList.add(`theme-${theme}`);
            }
            
            // Save preference
            localStorage.setItem('pinklemon-theme', theme);
        });
    });
    
    // Load saved theme
    const savedTheme = localStorage.getItem('pinklemon-theme');
    if (savedTheme && savedTheme !== 'pink') {
        document.body.classList.add(`theme-${savedTheme}`);
        colorButtons.forEach(btn => {
            btn.classList.remove('active');
            if (btn.getAttribute('data-theme') === savedTheme) {
                btn.classList.add('active');
            }
        });
    }
    
    // Toggle background animals
    if (animalsToggle && floatingAnimals) {
        animalsToggle.addEventListener('change', () => {
            floatingAnimals.style.display = animalsToggle.checked ? 'block' : 'none';
        });
    }
    
    // ============================================
    // Sparkle Effects (follows mouse)
    // ============================================
    const sparkleContainer = document.getElementById('sparkleContainer');
    let sparkleEnabled = true;
    
    function createSparkle(x, y) {
        if (!sparkleEnabled || !sparkleContainer) return;
        
        const sparkle = document.createElement('div');
        sparkle.className = 'sparkle';
        sparkle.style.left = (x + (Math.random() - 0.5) * 30) + 'px';
        sparkle.style.top = (y + (Math.random() - 0.5) * 30) + 'px';
        sparkle.style.background = `radial-gradient(circle, ${getRandomColor()} 0%, transparent 70%)`;
        sparkleContainer.appendChild(sparkle);
        
        setTimeout(() => sparkle.remove(), 1000);
    }
    
    function getRandomColor() {
        const colors = ['#FFB6C1', '#FFD700', '#E8A0A8', '#DDA0DD', '#87CEEB', '#FFF'];
        return colors[Math.floor(Math.random() * colors.length)];
    }
    
    document.addEventListener('mousemove', (e) => {
        if (Math.random() > 0.85) {
            createSparkle(e.clientX, e.clientY);
        }
    });
    
    if (sparkleToggle) {
        sparkleToggle.addEventListener('change', () => {
            sparkleEnabled = sparkleToggle.checked;
        });
    }
    
    // ============================================
    // Bubble Rain Effect
    // ============================================
    const bubbleContainer = document.getElementById('bubbleContainer');
    let bubbleInterval = null;
    
    function createBubble() {
        if (!bubbleContainer) return;
        const bubble = document.createElement('div');
        bubble.className = 'bubble';
        
        const size = Math.random() * 40 + 20;
        bubble.style.width = size + 'px';
        bubble.style.height = size + 'px';
        bubble.style.left = Math.random() * window.innerWidth + 'px';
        bubble.style.setProperty('--drift', (Math.random() - 0.5) * 200 + 'px');
        bubble.style.animationDuration = (Math.random() * 4 + 6) + 's';
        
        bubble.addEventListener('click', () => {
            bubble.classList.add('pop');
            for (let i = 0; i < 5; i++) {
                createSparkle(
                    parseInt(bubble.style.left) + size/2,
                    window.innerHeight - 100
                );
            }
            setTimeout(() => bubble.remove(), 300);
        });
        
        bubbleContainer.appendChild(bubble);
        
        setTimeout(() => {
            if (bubble.parentNode) bubble.remove();
        }, 10000);
    }
    
    if (bubbleToggle) {
        bubbleToggle.addEventListener('change', () => {
            if (bubbleToggle.checked) {
                bubbleInterval = setInterval(createBubble, 500);
            } else {
                clearInterval(bubbleInterval);
                if (bubbleContainer) bubbleContainer.innerHTML = '';
            }
        });
    }
    
    // ============================================
    // Background Animal Interactions
    // ============================================
    const bgAnimals = document.querySelectorAll('.bg-animal');
    
    bgAnimals.forEach(animal => {
        animal.addEventListener('click', () => {
            animal.classList.add('pop');
            
            const rect = animal.getBoundingClientRect();
            for (let i = 0; i < 5; i++) {
                setTimeout(() => {
                    const heart = document.createElement('div');
                    heart.className = 'click-heart';
                    heart.textContent = '💕';
                    heart.style.left = (rect.left + rect.width/2 + (Math.random() - 0.5) * 60) + 'px';
                    heart.style.top = (rect.top + rect.height/2 + (Math.random() - 0.5) * 60) + 'px';
                    if (clickEffects) clickEffects.appendChild(heart);
                    setTimeout(() => heart.remove(), 1000);
                }, i * 50);
            }
            
            setTimeout(() => animal.classList.remove('pop'), 500);
        });
        
        animal.style.pointerEvents = 'auto';
    });
    
    // ============================================
    // Mascot Interactions
    // ============================================
    const mascot = document.getElementById('mascot');
    const mascotSpeech = document.getElementById('mascotSpeech');
    
    const mascotMessages = [
        "Hi there! Welcome to PinkLemon! 💕",
        "Looking for something cute? 🐰",
        "All items are handmade with love! 🧶",
        "Check out our patterns! 📝",
        "Have a wonderful day! ✨",
        "You're amazing! 💖",
        "Thanks for visiting! 🍋",
        "Crochet is life! 🌸",
        "Hugs and stitches! 🎀",
        "Made with yarn and dreams! 🌈"
    ];
    
    let mascotIndex = 0;
    
    if (mascot && mascotSpeech) {
        const mascotBody = mascot.querySelector('.mascot-body');
        
        // Show initial message after delay
        setTimeout(() => {
            mascotSpeech.classList.add('show');
            setTimeout(() => mascotSpeech.classList.remove('show'), 4000);
        }, 2000);
        
        if (mascotBody) {
            mascotBody.addEventListener('click', () => {
                mascotIndex = (mascotIndex + 1) % mascotMessages.length;
                mascotSpeech.querySelector('p').textContent = mascotMessages[mascotIndex];
                mascotSpeech.classList.add('show');
                
                const mascotEmojis = ['🐰', '🐥', '🐻', '🐷', '🦊', '🐱'];
                mascotBody.textContent = mascotEmojis[Math.floor(Math.random() * mascotEmojis.length)];
                
                setTimeout(() => mascotSpeech.classList.remove('show'), 4000);
            });
        }
    }
    
    // ============================================
    // Confetti Button
    // ============================================
    const confettiBtn = document.getElementById('confettiBtn');
    
    function createConfetti() {
        const colors = ['#FFB6C1', '#FFD700', '#87CEEB', '#DDA0DD', '#98FB98', '#FFA07A', '#E8A0A8'];
        const shapes = ['■', '●', '▲', '♦', '★', '♥'];
        
        for (let i = 0; i < 50; i++) {
            setTimeout(() => {
                const confetti = document.createElement('div');
                confetti.className = 'confetti';
                confetti.textContent = shapes[Math.floor(Math.random() * shapes.length)];
                confetti.style.left = Math.random() * window.innerWidth + 'px';
                confetti.style.color = colors[Math.floor(Math.random() * colors.length)];
                confetti.style.fontSize = (Math.random() * 15 + 10) + 'px';
                confetti.style.animationDuration = (Math.random() * 2 + 2) + 's';
                document.body.appendChild(confetti);
                
                setTimeout(() => confetti.remove(), 3000);
            }, i * 30);
        }
    }
    
    if (confettiBtn) {
        confettiBtn.addEventListener('click', createConfetti);
    }
    
    // ============================================
    // Music Toggle (placeholder)
    // ============================================
    const musicBtn = document.getElementById('musicBtn');
    let musicPlaying = false;
    
    if (musicBtn && mascotSpeech) {
        musicBtn.addEventListener('click', () => {
            musicPlaying = !musicPlaying;
            musicBtn.classList.toggle('active', musicPlaying);
            musicBtn.textContent = musicPlaying ? '🔊' : '🎵';
            
            mascotSpeech.querySelector('p').textContent = musicPlaying 
                ? "🎵 Imagine cute music playing! 🎵" 
                : "Music paused! 🔇";
            mascotSpeech.classList.add('show');
            setTimeout(() => mascotSpeech.classList.remove('show'), 3000);
        });
    }
    
    // ============================================
    // Mobile Navigation Toggle
    // ============================================
    const navToggle = document.getElementById('navToggle');
    const navMenu = document.getElementById('navMenu');
    
    if (navToggle && navMenu) {
        navToggle.addEventListener('click', function() {
            navMenu.classList.toggle('active');
            const spans = navToggle.querySelectorAll('span');
            spans.forEach(span => span.classList.toggle('active'));
        });
    }
    
    const navLinks = document.querySelectorAll('.nav-link');
    navLinks.forEach(link => {
        link.addEventListener('click', function() {
            if (navMenu) navMenu.classList.remove('active');
        });
    });
    
    // ============================================
    // Active Navigation Link on Scroll
    // ============================================
    const sections = document.querySelectorAll('section[id]');
    
    function updateActiveLink() {
        const scrollY = window.pageYOffset;
        
        sections.forEach(section => {
            const sectionHeight = section.offsetHeight;
            const sectionTop = section.offsetTop - 150;
            const sectionId = section.getAttribute('id');
            
            if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
                navLinks.forEach(link => {
                    link.classList.remove('active');
                    if (link.getAttribute('href') === `#${sectionId}`) {
                        link.classList.add('active');
                    }
                });
            }
        });
    }
    
    window.addEventListener('scroll', updateActiveLink);
    
    // ============================================
    // Product Filter Functionality
    // ============================================
    const filterButtons = document.querySelectorAll('.filter-btn');
    const productCards = document.querySelectorAll('.product-card');
    
    filterButtons.forEach(button => {
        button.addEventListener('click', function() {
            // Remove active class from all buttons
            filterButtons.forEach(btn => btn.classList.remove('active'));
            // Add active class to clicked button
            this.classList.add('active');
            
            const filterValue = this.getAttribute('data-filter');
            
            productCards.forEach((card, i) => {
                const category = card.getAttribute('data-category');
                
                if (filterValue === 'all' || category === filterValue) {
                    card.style.display = 'block';
                    card.style.animation = `fadeInUp 0.5s ease ${i * 0.05}s forwards`;
                } else {
                    card.style.display = 'none';
                }
            });
            setTimeout(masonryLayout, 50);
        });
    });

    // ============================================
    // Masonry Layout
    // ============================================
    function masonryLayout() {
        const grid = document.querySelector('.products-grid');
        if (!grid) return;
        const rowUnit = 10;
        const rowGap = parseInt(getComputedStyle(grid).columnGap) || 30;
        grid.querySelectorAll('.product-card').forEach(card => {
            card.style.gridRowEnd = '';
            const height = card.getBoundingClientRect().height;
            if (!height) return;
            card.style.gridRowEnd = 'span ' + Math.ceil((height + rowGap) / rowUnit);
        });
    }

    masonryLayout();
    window.addEventListener('resize', masonryLayout);
    // Re-run after images finish loading so heights are accurate
    document.querySelectorAll('.products-grid .product-img').forEach(img => {
        img.addEventListener('load', masonryLayout);
    });
    
    // ============================================
    // Product Image Gallery Dots
    // ============================================
    function setProductCardImage(card, img, src) {
        img.src = src;
        const isCustomPoster = src.includes('Custom_Fi');
        const frame = img.closest('.product-image');
        img.classList.toggle('custom-poster-img', isCustomPoster);
        if (frame) frame.classList.toggle('custom-poster-frame', isCustomPoster);
        requestAnimationFrame(masonryLayout);
    }

    document.querySelectorAll('.gallery-dot').forEach(dot => {
        dot.addEventListener('mouseenter', function() {
            const card = this.closest('.product-card');
            const img = card.querySelector('.product-img');
            const newSrc = this.dataset.img;
            if (img && newSrc) {
                setProductCardImage(card, img, newSrc);
                card.querySelectorAll('.gallery-dot').forEach(d => d.classList.remove('active'));
                this.classList.add('active');
            }
        });
        dot.addEventListener('click', function() {
            const card = this.closest('.product-card');
            const img = card.querySelector('.product-img');
            const newSrc = this.dataset.img;
            if (img && newSrc) {
                setProductCardImage(card, img, newSrc);
                card.querySelectorAll('.gallery-dot').forEach(d => d.classList.remove('active'));
                this.classList.add('active');
            }
        });
    });

    // ============================================
    // Product Variant Buttons (Colour/Shape)
    // ============================================
    document.querySelectorAll('.variant-btn').forEach(btn => {
        btn.addEventListener('click', function() {
            const card = this.closest('.product-card');
            const img = card.querySelector('.product-img');
            const dotsContainer = card.querySelector('.product-gallery-dots');
            const mainImg = this.dataset.mainImg;
            const gallery = this.dataset.gallery;
            
            // Update active variant button
            card.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
            this.classList.add('active');
            
            // Update main image
            if (img && mainImg) {
                setProductCardImage(card, img, mainImg);
            }
            
            // Update gallery dots
            if (dotsContainer && gallery) {
                const images = gallery.split(',');
                dotsContainer.innerHTML = '';
                images.forEach((src, i) => {
                    const dot = document.createElement('span');
                    dot.className = 'gallery-dot' + (i === 0 ? ' active' : '');
                    dot.dataset.img = src;
                    dot.addEventListener('mouseenter', function() {
                        setProductCardImage(card, img, this.dataset.img);
                        dotsContainer.querySelectorAll('.gallery-dot').forEach(d => d.classList.remove('active'));
                        this.classList.add('active');
                    });
                    dot.addEventListener('click', function() {
                        setProductCardImage(card, img, this.dataset.img);
                        dotsContainer.querySelectorAll('.gallery-dot').forEach(d => d.classList.remove('active'));
                        this.classList.add('active');
                    });
                    dotsContainer.appendChild(dot);
                });
            }
            
            // Update product name with variant
            const variantName = this.dataset.variant;
            const baseName = card.dataset.name;
            card.dataset.selectedVariant = variantName;
            
            // Show/hide custom colour input
            let customInput = card.querySelector('.custom-colour-input');
            if (this.classList.contains('custom-variant')) {
                if (!customInput) {
                    customInput = document.createElement('div');
                    customInput.className = 'custom-colour-input';
                    customInput.innerHTML = '<input type="text" class="custom-colour-field" placeholder="Type your colour..." maxlength="30">';
                    this.closest('.product-variants').after(customInput);
                }
                customInput.style.display = 'block';
                const field = customInput.querySelector('.custom-colour-field');
                field.focus();
                field.addEventListener('input', function() {
                    card.dataset.selectedVariant = 'Custom: ' + this.value;
                });
            } else {
                if (customInput) customInput.style.display = 'none';
            }
            
            // Update displayed price if custom variant has extra cost
            const basePrice = parseFloat(card.dataset.price);
            const priceAdd = parseFloat(this.dataset.priceAdd || 0);
            const newPrice = (basePrice + priceAdd).toFixed(2);
            const priceEl = card.querySelector('.price');
            if (priceEl) {
                priceEl.textContent = '£' + newPrice;
            }
            card.dataset.currentPrice = newPrice;
        });
    });

    // Show custom colour input for any card that already has a custom variant active on load
    document.querySelectorAll('.variant-btn.custom-variant.active').forEach(btn => {
        const card = btn.closest('.product-card');
        const customInput = document.createElement('div');
        customInput.className = 'custom-colour-input';
        customInput.innerHTML = '<input type="text" class="custom-colour-field" placeholder="Type your colour..." maxlength="30">';
        btn.closest('.product-variants').after(customInput);
        customInput.querySelector('.custom-colour-field').addEventListener('input', function() {
            card.dataset.selectedVariant = 'Custom: ' + this.value;
        });
    });

    // ============================================
    // Add to Cart Animation - Enhanced
    // ============================================
    const addToCartButtons = document.querySelectorAll('.add-to-cart');
    
    addToCartButtons.forEach(button => {
        button.addEventListener('click', function() {
            // Custom order button opens modal — skip animation here
            if (this.classList.contains('open-custom-modal')) return;
            const originalText = this.textContent;
            this.textContent = 'Added! ✓';
            this.style.background = '#4CAF50';
            
            // Create flying cart animation
            const rect = this.getBoundingClientRect();
            for (let i = 0; i < 3; i++) {
                const particle = document.createElement('div');
                particle.className = 'click-heart';
                particle.textContent = '🛒';
                particle.style.left = rect.left + 'px';
                particle.style.top = rect.top + 'px';
                if (clickEffects) clickEffects.appendChild(particle);
                setTimeout(() => particle.remove(), 1000);
            }
            
            setTimeout(() => {
                this.textContent = originalText;
                this.style.background = '';
            }, 2000);
        });
    });
    
    // ============================================
    // Buy Pattern Button Animation
    // ============================================
    const buyPatternButtons = document.querySelectorAll('.pattern-footer .btn-primary');
    
    buyPatternButtons.forEach(button => {
        button.addEventListener('click', function() {
            const originalText = this.textContent;
            this.textContent = 'Added to Cart! 🎉';
            createConfetti();
            
            setTimeout(() => {
                this.textContent = originalText;
            }, 2000);
        });
    });
    
    // ============================================
    // Contact Form Submission
    // ============================================
    const contactForm = document.querySelector('.contact-form');
    
    if (contactForm) {
        contactForm.addEventListener('submit', function(e) {
            e.preventDefault();
            
            const submitButton = this.querySelector('button[type="submit"]');
            const originalText = submitButton.textContent;
            
            submitButton.textContent = 'Sending...';
            submitButton.disabled = true;
            
            // Simulate form submission
            setTimeout(() => {
                submitButton.textContent = 'Message Sent! 💌';
                submitButton.style.background = '#4CAF50';
                
                // Reset form
                this.reset();
                
                setTimeout(() => {
                    submitButton.textContent = originalText;
                    submitButton.style.background = '';
                    submitButton.disabled = false;
                }, 3000);
            }, 1500);
        });
    }
    
    // ============================================
    // Scroll Animations
    // ============================================
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };
    
    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, observerOptions);
    
    // Observe elements for scroll animations
    const animatedElements = document.querySelectorAll('.product-card, .pattern-card, .review-card, .gallery-item, .about-content, .about-image-frame');
    
    animatedElements.forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(el);
    });
    
    // ============================================
    // Floating Elements Random Movement
    // ============================================
    const floatingElements = document.querySelectorAll('.floating-element');
    
    floatingElements.forEach(el => {
        // Add slight random delay to animations
        el.style.animationDelay = `${Math.random() * 2}s`;
    });
    
    // ============================================
    // Gallery Lightbox Effect - Enhanced
    // ============================================
    const galleryItems = document.querySelectorAll('.gallery-item');
    
    galleryItems.forEach(item => {
        item.addEventListener('click', function() {
            this.style.transform = 'scale(0.95)';
            setTimeout(() => {
                this.style.transform = '';
            }, 200);
            
            // Heart burst effect
            const rect = this.getBoundingClientRect();
            for (let i = 0; i < 5; i++) {
                setTimeout(() => {
                    const heart = document.createElement('div');
                    heart.className = 'click-heart';
                    heart.textContent = '💗';
                    heart.style.left = (rect.left + rect.width/2 + (Math.random() - 0.5) * 100) + 'px';
                    heart.style.top = (rect.top + rect.height/2 + (Math.random() - 0.5) * 100) + 'px';
                    if (clickEffects) clickEffects.appendChild(heart);
                    setTimeout(() => heart.remove(), 1000);
                }, i * 50);
            }
        });
    });
    
    // ============================================
    // Interactive Stars
    // ============================================
    const stars = document.querySelectorAll('.star');
    stars.forEach(star => {
        star.style.pointerEvents = 'auto';
        star.addEventListener('click', () => {
            star.style.animation = 'starSpin 0.5s ease';
            
            // Create sparkles around star
            const rect = star.getBoundingClientRect();
            for (let i = 0; i < 8; i++) {
                createSparkle(
                    rect.left + rect.width/2 + (Math.random() - 0.5) * 50,
                    rect.top + rect.height/2 + (Math.random() - 0.5) * 50
                );
            }
            
            setTimeout(() => {
                star.style.animation = 'twinkle 3s ease-in-out infinite, starFloat 15s ease-in-out infinite';
            }, 500);
        });
    });
    
    // ============================================
    // Smooth Scroll for Anchor Links
    // ============================================
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });
    
    // ============================================
    // Fun Easter Egg - Konami Code
    // ============================================
    let konamiCode = [];
    const konamiSequence = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
    
    document.addEventListener('keydown', function(e) {
        konamiCode.push(e.key);
        konamiCode = konamiCode.slice(-10);
        
        if (konamiCode.join(',') === konamiSequence.join(',')) {
            createConfetti();
            document.body.style.animation = 'rainbow 2s ease';
            
            if (mascotSpeech) {
                mascotSpeech.querySelector('p').textContent = "🎉 Secret unlocked! You're awesome! 🎉";
                mascotSpeech.classList.add('show');
            }
            
            setTimeout(() => {
                document.body.style.animation = '';
                if (mascotSpeech) mascotSpeech.classList.remove('show');
            }, 3000);
        }
    });
    
    // ============================================
    // Random Mascot Pop-ups
    // ============================================
    setInterval(() => {
        if (mascotSpeech && Math.random() > 0.7 && !mascotSpeech.classList.contains('show')) {
            const randomMessages = [
                "Still here if you need me! 💕",
                "Found something you like? 🌸",
                "Don't forget to check patterns! 📝",
                "You have great taste! ✨"
            ];
            mascotSpeech.querySelector('p').textContent = randomMessages[Math.floor(Math.random() * randomMessages.length)];
            mascotSpeech.classList.add('show');
            setTimeout(() => mascotSpeech.classList.remove('show'), 4000);
        }
    }, 30000);

    // ============================================
    // SHOPPING CART FUNCTIONALITY
    // ============================================
    
    // Cart state - load from localStorage or start empty
    let cart = JSON.parse(localStorage.getItem('pinklemonCart')) || [];
    
    // DOM Elements
    const cartItemsContainer = document.querySelector('.cart-items');
    const emptyCartMessage = document.querySelector('.empty-cart-message');
    const cartSubtotal = document.getElementById('cartSubtotal');
    const cartShipping = document.getElementById('cartShipping');
    const cartTotal = document.getElementById('cartTotal');
    const cartCountElement = document.getElementById('cartCount');
    const checkoutBtn = document.querySelector('.checkout-btn');
    const checkoutModal = document.getElementById('checkoutModal');
    const closeModal = document.getElementById('checkoutModalClose');
    const startCheckoutBtn = document.getElementById('startCheckoutBtn');
    const shippingZoneCards = document.querySelectorAll('.shipping-zone-card');
    const shippingZoneError = document.getElementById('shippingZoneError');
    let selectedShippingZone = '';
    const CUSTOM_ORDER_NAME = 'Custom Made Crochet Figures - Full Size';
    const CHIBI_CUSTOM_ORDER_NAME = 'Custom Made Crochet Figures - Small Chibi';
    const CUSTOM_KEYRING_ORDER_NAME = 'Custom Made Crochet Keyring - Mini';
    const MINI_CUSTOM_ORDER_NAME = 'MINI Custom Crochet Character - Game/Anime Figure Handmade';
    const CUSTOM_ORDER_NAMES = new Set([CUSTOM_ORDER_NAME, CHIBI_CUSTOM_ORDER_NAME, CUSTOM_KEYRING_ORDER_NAME, MINI_CUSTOM_ORDER_NAME, 'Custom Made Crochet Figure']);
    const CUSTOM_ORDER_RETURN_NOTICE = 'Custom orders are made to order and cannot be returned or refunded once purchased. I WILL send you a final picture once I have finished before it is sent off for any final details you would like.';
    const HTML_ESCAPE_CHARS = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };

    function escapeCartText(value) {
        return String(value === undefined || value === null ? '' : value).replace(/[&<>"']/g, char => HTML_ESCAPE_CHARS[char]);
    }

    function isCustomCartItem(item) {
        if (!item) return false;

        return Boolean(
            item.isCustomOrder ||
            item.customDescription ||
            item.customImageRef ||
            CUSTOM_ORDER_NAMES.has(item.name)
        );
    }
    
    // Save cart to localStorage
    function saveCart() {
        localStorage.setItem('pinklemonCart', JSON.stringify(cart));
    }
    
    // Update cart count in navigation
    function updateCartCount() {
        const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);
        if (cartCountElement) {
            cartCountElement.textContent = totalItems;
        }
        // Keep mobile FAB badge in sync
        const fabCount = document.getElementById('mobileCartFabCount');
        if (fabCount) {
            fabCount.textContent = totalItems;
            fabCount.dataset.count = totalItems;
        }
    }
    
    // Calculate totals
    function calculateTotals() {
        const subtotal = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
        
        if (cartSubtotal) cartSubtotal.textContent = '£' + subtotal.toFixed(2);
        if (cartShipping) cartShipping.textContent = 'Choose before checkout';
        if (cartTotal) cartTotal.textContent = '£' + subtotal.toFixed(2);
    }
    
    // Render cart items
    function renderCart() {
        if (!cartItemsContainer) return;
        
        const cartSummary = document.getElementById('cartSummary');
        const cartEmpty = document.getElementById('cartEmpty');
        
        if (cart.length === 0) {
            cartItemsContainer.innerHTML = '';
            if (cartEmpty) cartEmpty.style.display = 'block';
            if (cartSummary) cartSummary.style.display = 'none';
            calculateTotals();
            updateCartCount();
            return;
        }
        
        if (cartEmpty) cartEmpty.style.display = 'none';
        if (cartSummary) cartSummary.style.display = 'block';
        
        cartItemsContainer.innerHTML = cart.map((item, index) => {
            const customDescription = String(item.customDescription || '');
            const customDescriptionPreview = customDescription.substring(0, 80);
            const hasCustomWarning = isCustomCartItem(item);

            return `
            <div class="cart-item" data-index="${index}">
                <div class="cart-item-image"><img src="${escapeCartText(item.image || '')}" alt="${escapeCartText(item.name)}" loading="lazy" decoding="async" style="width:50px;height:50px;object-fit:cover;border-radius:8px;"></div>
                <div class="cart-item-details">
                    <h4>${escapeCartText(item.name)}</h4>
                    <p class="cart-item-price">£${item.price.toFixed(2)}</p>
                    ${customDescription ? `<p class="cart-item-custom-desc">"${escapeCartText(customDescriptionPreview)}${customDescription.length > 80 ? '...' : ''}"</p>` : ''}
                    ${item.customImageRef ? `<p class="cart-item-custom-img-note">Reference image attached</p>` : ''}
                    ${hasCustomWarning ? `<p class="cart-item-custom-warning">${CUSTOM_ORDER_RETURN_NOTICE}</p>` : ''}
                    <div class="cart-item-quantity">
                        <button class="quantity-btn minus" onclick="updateQuantity(${index}, -1)">-</button>
                        <span class="quantity">${item.quantity}</span>
                        <button class="quantity-btn plus" onclick="updateQuantity(${index}, 1)">+</button>
                    </div>
                </div>
                <button class="remove-item" onclick="removeFromCart(${index})">✕</button>
            </div>
        `;
        }).join('');
        
        calculateTotals();
        updateCartCount();
    }
    
    // Add item to cart
    window.addToCart = function(name, price, image, customData) {
        // Check if item already exists (for custom orders, always add new since each is unique)
        const isCustomOrder = customData && (customData.customDescription || customData.customImageRef);
        const existingIndex = !isCustomOrder ? cart.findIndex(item => item.name === name && !item.customDescription) : -1;
        
        if (existingIndex > -1) {
            cart[existingIndex].quantity += 1;
        } else {
            const item = {
                name: name,
                price: parseFloat(price),
                image: image || '',
                quantity: 1
            };
            if (isCustomOrder) {
                item.isCustomOrder = true;
                item.customDescription = customData.customDescription || '';
                item.customImageRef = customData.customImageRef || '';
                item.nonReturnableNotice = CUSTOM_ORDER_RETURN_NOTICE;
            }
            cart.push(item);
        }
        
        saveCart();
        renderCart();
        
        // Show notification
        showCartNotification(isCustomOrder ? `${name} added to cart. ${CUSTOM_ORDER_RETURN_NOTICE}` : name + ' added to cart! 🛒');
        
        // Animate cart icon
        if (cartCountElement) {
            cartCountElement.style.transform = 'scale(1.5)';
            setTimeout(() => cartCountElement.style.transform = 'scale(1)', 300);
        }
        
        // Open cart panel
        const cartPanel = document.getElementById('cartPanel');
        const cartOverlay = document.getElementById('cartOverlay');
        if (cartPanel && cartOverlay) {
            cartPanel.classList.add('active');
            cartOverlay.classList.add('active');
            document.body.style.overflow = 'hidden';
        }
        
        // Trigger confetti effect
        createMiniConfetti();
    };
    
    // Update quantity
    window.updateQuantity = function(index, change) {
        cart[index].quantity += change;
        
        if (cart[index].quantity <= 0) {
            cart.splice(index, 1);
        }
        
        saveCart();
        renderCart();
    };
    
    // Remove item from cart
    window.removeFromCart = function(index) {
        const itemName = cart[index].name;
        cart.splice(index, 1);
        saveCart();
        renderCart();
        showCartNotification(itemName + ' removed from cart');
    };
    
    // Show cart notification
    function showCartNotification(message) {
        const notification = document.createElement('div');
        notification.className = 'cart-notification';
        notification.innerHTML = `<span>${message}</span>`;
        document.body.appendChild(notification);
        
        setTimeout(() => notification.classList.add('show'), 10);
        setTimeout(() => {
            notification.classList.remove('show');
            setTimeout(() => notification.remove(), 300);
        }, 2500);
    }
    
    // Mini confetti for add to cart
    function createMiniConfetti() {
        const colors = ['#FADADD', '#F5C6CB', '#FFE4B5', '#E8DED1', '#FFB6C1'];
        const emojis = ['💗', '🌸', '✨', '🎀'];
        
        for (let i = 0; i < 12; i++) {
            setTimeout(() => {
                const confetti = document.createElement('div');
                confetti.style.cssText = `
                    position: fixed;
                    top: 20%;
                    right: 5%;
                    font-size: ${Math.random() * 15 + 15}px;
                    pointer-events: none;
                    z-index: 10000;
                    animation: confettiFall 1.5s forwards;
                `;
                confetti.textContent = emojis[Math.floor(Math.random() * emojis.length)];
                document.body.appendChild(confetti);
                
                setTimeout(() => confetti.remove(), 1500);
            }, i * 50);
        }
    }

    function setCheckoutLoading(isLoading) {
        if (checkoutBtn) {
            checkoutBtn.textContent = isLoading ? 'Processing... ✨' : 'Checkout 💖';
            checkoutBtn.disabled = isLoading;
            checkoutBtn.style.opacity = isLoading ? '0.7' : '1';
        }

        if (startCheckoutBtn) {
            startCheckoutBtn.textContent = isLoading ? 'Redirecting... ✨' : 'Continue to Secure Checkout';
            startCheckoutBtn.disabled = isLoading;
            startCheckoutBtn.style.opacity = isLoading ? '0.7' : '1';
        }
    }

    function updateShippingZoneSelection() {
        shippingZoneCards.forEach(card => {
            card.classList.toggle('selected', card.dataset.shippingZone === selectedShippingZone);
        });

        if (shippingZoneError) {
            shippingZoneError.textContent = '';
        }
    }

    function openCheckoutModal() {
        if (!checkoutModal) return;
        checkoutModal.classList.add('open');
        checkoutModal.setAttribute('aria-hidden', 'false');
    }

    function closeCheckoutModal() {
        if (!checkoutModal) return;
        checkoutModal.classList.remove('open');
        checkoutModal.setAttribute('aria-hidden', 'true');
        if (shippingZoneError) {
            shippingZoneError.textContent = '';
        }
    }

    // --- Shopify checkout -------------------------------------------------
    // Pushes the local cart into Shopify's cart, then hands off to Shopify's
    // hosted checkout, which owns shipping rates, tax and payment.
    // The zone the shopper picks is recorded on the order as a note; the
    // amount they actually pay comes from Shopify's shipping settings.
    const ZONE_LABELS = { uk: 'UK', europe: 'Europe', international: 'Rest of World' };
    function shopifyProductFor(item) {
        if (!window.PINKLEMON || !window.PINKLEMON.products) return null;
        return window.PINKLEMON.products.find(p => p.name === item.name) || null;
    }

    function shopifyVariantFor(item) {
        const p = shopifyProductFor(item);
        if (!p || !p.variants) return null;
        const names = Object.keys(p.variants);
        if (!names.length) return null;
        if (item.variant && p.variants[item.variant]) return p.variants[item.variant];
        // Single-variant products come through as "Default Title"
        return p.variants[names[0]];
    }

    function shopifyLineProperties(item) {
        const props = {};
        if (item.variant && !shopifyProductFor(item)?.variants?.[item.variant]) {
            props['Option'] = item.variant;
        }
        if (item.customDescription) props['Your description'] = item.customDescription;
        if (item.customImageRef) {
            const base = (window.PINKLEMON && window.PINKLEMON.api_base) || '';
            props['Reference image'] = base
                ? base + '/api/get-reference?key=' + encodeURIComponent(item.customImageRef)
                : item.customImageRef;
        }
        if (isCustomCartItem(item)) props['Terms'] = CUSTOM_ORDER_RETURN_NOTICE;
        return props;
    }

    async function beginCheckout() {
        if (!selectedShippingZone) {
            if (shippingZoneError) {
                shippingZoneError.textContent = 'Please choose UK or International before continuing.';
            }
            return;
        }

        setCheckoutLoading(true);

        try {
            const lines = [];
            const unavailable = [];

            for (const item of cart) {
                const variant = shopifyVariantFor(item);
                if (!variant || !variant.id) { unavailable.push(item.name); continue; }
                if (variant.available === false) { unavailable.push(item.name + ' (sold out)'); continue; }
                lines.push({
                    id: variant.id,
                    quantity: item.quantity,
                    properties: shopifyLineProperties(item)
                });
            }

            if (unavailable.length) {
                throw new Error('Not available right now: ' + unavailable.join(', '));
            }
            if (!lines.length) {
                throw new Error('Your cart is empty!');
            }

            // Start from a clean Shopify cart so quantities can't double up
            await fetch(window.PINKLEMON.routes.cart_clear, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            });

            const addRes = await fetch(window.PINKLEMON.routes.cart_add, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: lines })
            });

            if (!addRes.ok) {
                const err = await addRes.json().catch(() => ({}));
                throw new Error(err.description || err.message || 'Could not start checkout');
            }

            // Record the zone the shopper picked so it shows on the order
            await fetch(window.PINKLEMON.routes.cart_update, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    attributes: { 'Delivery zone': ZONE_LABELS[selectedShippingZone] || selectedShippingZone }
                })
            }).catch(() => {});

            window.location.href = window.PINKLEMON.routes.checkout;
        } catch (error) {
            console.error('Checkout error:', error);
            showCartNotification(error.message || 'Checkout is unavailable right now.');
            setCheckoutLoading(false);
        }
    }
    
    // Checkout functionality - Stripe Checkout
    if (checkoutBtn) {
        checkoutBtn.addEventListener('click', () => {
            if (cart.length === 0) {
                showCartNotification('Your cart is empty! 🛒');
                return;
            }

            openCheckoutModal();
        });
    }

    shippingZoneCards.forEach(card => {
        card.addEventListener('click', () => {
            selectedShippingZone = card.dataset.shippingZone || '';
            updateShippingZoneSelection();
        });
    });

    if (startCheckoutBtn) {
        startCheckoutBtn.addEventListener('click', beginCheckout);
    }
    
    // Close modal
    if (closeModal) {
        closeModal.addEventListener('click', closeCheckoutModal);
    }
    
    // Close modal on outside click
    if (checkoutModal) {
        checkoutModal.addEventListener('click', (e) => {
            if (e.target === checkoutModal) {
                closeCheckoutModal();
            }
        });
    }

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && checkoutModal && checkoutModal.classList.contains('open')) {
            closeCheckoutModal();
        }
    });
    
    // Add to cart from product cards
    document.querySelectorAll('.add-to-cart').forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            // Custom order cards are handled by the custom modal — skip them here
            if (btn.classList.contains('open-custom-modal')) return;
            const card = btn.closest('.product-card');
            if (card) {
                const variant = card.dataset.selectedVariant || '';
                const baseName = card.dataset.name;
                const name = variant && variant !== 'All Friends' ? baseName + ' (' + variant + ')' : baseName;
                const price = card.dataset.currentPrice || card.dataset.price;
                const image = card.querySelector('.product-img') ? card.querySelector('.product-img').src : '';
                addToCart(name, price, image);
            }
        });
    });
    
    // Add to cart from pattern cards
    document.querySelectorAll('.add-pattern-to-cart').forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const card = btn.closest('.pattern-card');
            if (card) {
                const name = card.dataset.name;
                const price = card.dataset.price;
                const emoji = card.dataset.emoji;
                addToCart(name, price, emoji);
            }
        });
    });
    
    // Initialize cart on page load
    renderCart();

    // ============================================
    // Custom Made Crochet Figures — Order Modal
    // ============================================
    const customOrderModal = document.getElementById('customOrderModal');
    const customOrderModalClose = document.getElementById('customOrderModalClose');
    const customAddToCartBtn = document.getElementById('customAddToCartBtn');
    const customCharacterDesc = document.getElementById('customCharacterDesc');
    const customDescCount = document.getElementById('customDescCount');
    const customReferenceImg = document.getElementById('customReferenceImg');
    const customUploadArea = document.getElementById('customUploadArea');
    const customUploadPlaceholder = document.getElementById('customUploadPlaceholder');
    const customUploadPreview = document.getElementById('customUploadPreview');
    const customPreviewImg = document.getElementById('customPreviewImg');
    const removePreviewBtn = document.getElementById('removePreviewBtn');
    const customFormError = document.getElementById('customFormError');
    const customOrderMainImg = document.getElementById('customOrderMainImg');
    const customOrderGalleryThumbs = document.getElementById('customOrderGalleryThumbs');
    const customOrderModalTitle = document.getElementById('customOrderModalTitle');
    const customOrderPrice = document.getElementById('customOrderPrice');
    const customOrderDescription = document.getElementById('customOrderDescription');

    let selectedReferenceFile = null;
    let activeCustomOrder = {
        name: CUSTOM_ORDER_NAME,
        price: '65.00',
        image: 'assets/Custom_Fi.png'
    };

    function getCustomGalleryFromCard(card) {
        if (!card) return [activeCustomOrder.image];

        if (card.dataset.customGallery) {
            return card.dataset.customGallery
                .split(',')
                .map(src => src.trim())
                .filter(Boolean);
        }

        const gallery = Array.from(card.querySelectorAll('.gallery-dot'))
            .map(dot => dot.dataset.img)
            .filter(Boolean);

        if (gallery.length > 0) return gallery;

        const img = card.querySelector('.product-img');
        return img && img.getAttribute('src') ? [img.getAttribute('src')] : [activeCustomOrder.image];
    }

    function renderCustomOrderThumbs(gallery, productName) {
        if (!customOrderGalleryThumbs) return;
        customOrderGalleryThumbs.innerHTML = '';

        gallery.forEach((src, index) => {
            const thumb = document.createElement('img');
            thumb.src = src;
            thumb.className = 'custom-order-thumb' + (index === 0 ? ' active' : '');
            thumb.dataset.full = src;
            thumb.alt = index === 0 ? productName : `${productName} example ${index}`;
            thumb.loading = 'lazy';
            thumb.decoding = 'async';
            customOrderGalleryThumbs.appendChild(thumb);
        });
    }

    function setCustomOrderFromCard(card) {
        if (!card) return;

        const gallery = getCustomGalleryFromCard(card);
        const productName = card.dataset.name || CUSTOM_ORDER_NAME;
        const price = parseFloat(card.dataset.price || '65').toFixed(2);
        const mainImage = gallery[0] || activeCustomOrder.image;

        activeCustomOrder = {
            name: productName,
            price,
            image: mainImage
        };

        if (customOrderModalTitle) customOrderModalTitle.textContent = productName;
        if (customOrderPrice) customOrderPrice.textContent = `£${price}`;
        if (customOrderMainImg) {
            customOrderMainImg.src = mainImage;
            customOrderMainImg.alt = productName;
        }

        renderCustomOrderThumbs(gallery, productName);

        if (customOrderDescription && card.dataset.customDescription) {
            customOrderDescription.innerHTML = '';
            card.dataset.customDescription.split('||').forEach(line => {
                const text = line.trim();
                if (!text) return;
                const paragraph = document.createElement('p');
                paragraph.textContent = text;
                customOrderDescription.appendChild(paragraph);
            });
        }
    }

    function resetCustomOrderForm() {
        hideCustomFormError();
        if (customCharacterDesc) customCharacterDesc.value = '';
        if (customDescCount) {
            customDescCount.textContent = '0';
            const counter = customDescCount.closest('.textarea-counter');
            if (counter) {
                counter.classList.remove('near-limit');
                counter.classList.remove('below-min');
            }
        }
        selectedReferenceFile = null;
        if (customPreviewImg) customPreviewImg.src = '';
        if (customUploadPreview) customUploadPreview.style.display = 'none';
        if (customUploadPlaceholder) customUploadPlaceholder.style.display = 'flex';
        if (customReferenceImg) customReferenceImg.value = '';
        if (customAddToCartBtn) customAddToCartBtn.textContent = 'Add to Cart ✨';
        validateCustomForm();
    }

    function openCustomOrderModal(card) {
        if (!customOrderModal) return;
        setCustomOrderFromCard(card);
        resetCustomOrderForm();
        customOrderModal.classList.add('open');
        customOrderModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    }

    function closeCustomOrderModal() {
        if (!customOrderModal) return;
        customOrderModal.classList.remove('open');
        customOrderModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    }

    // Open modal when the custom figure card button is clicked
    document.querySelectorAll('.open-custom-modal').forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            openCustomOrderModal(btn.closest('.product-card'));
        });
    });

    if (customOrderModalClose) {
        customOrderModalClose.addEventListener('click', closeCustomOrderModal);
    }

    if (customOrderModal) {
        customOrderModal.addEventListener('click', (e) => {
            if (e.target === customOrderModal) closeCustomOrderModal();
        });
    }

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && customOrderModal && customOrderModal.classList.contains('open')) {
            closeCustomOrderModal();
        }
    });

    // Gallery thumbnails in modal
    if (customOrderGalleryThumbs) {
        customOrderGalleryThumbs.addEventListener('click', (e) => {
            const thumb = e.target.closest('.custom-order-thumb');
            if (!thumb) return;
            if (customOrderMainImg) customOrderMainImg.src = thumb.dataset.full;
            document.querySelectorAll('.custom-order-thumb').forEach(t => t.classList.remove('active'));
            thumb.classList.add('active');
        });
    }

    // Character description counter & validation
    function validateCustomForm() {
        const hasDesc = customCharacterDesc ? customCharacterDesc.value.trim().length > 0 : false;
        const hasImage = selectedReferenceFile !== null;
        if (customAddToCartBtn) {
            customAddToCartBtn.disabled = !(hasDesc && hasImage);
        }
    }

    if (customCharacterDesc) {
        customCharacterDesc.addEventListener('input', () => {
            const len = customCharacterDesc.value.length;
            if (customDescCount) {
                customDescCount.textContent = len;
                const counter = customDescCount.closest('.textarea-counter');
                if (counter) {
                    counter.classList.toggle('near-limit', len >= 400);
                    counter.classList.remove('below-min');
                }
            }
            validateCustomForm();
        });
    }

    // File upload handling
    function handleFileSelect(file) {
        if (!file) return;

        const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
        if (!allowedTypes.includes(file.type)) {
            showCustomFormError('Please upload a JPG, PNG, GIF or WEBP image.');
            return;
        }

        const maxBytes = 3 * 1024 * 1024; // 3MB
        if (file.size > maxBytes) {
            showCustomFormError('Image is too large. Please choose an image under 3MB.');
            return;
        }

        hideCustomFormError();
        selectedReferenceFile = file;

        const reader = new FileReader();
        reader.onload = (e) => {
            if (customPreviewImg) customPreviewImg.src = e.target.result;
            if (customUploadPlaceholder) customUploadPlaceholder.style.display = 'none';
            if (customUploadPreview) customUploadPreview.style.display = 'flex';
        };
        reader.readAsDataURL(file);

        validateCustomForm();
    }

    if (customReferenceImg) {
        customReferenceImg.addEventListener('change', (e) => {
            handleFileSelect(e.target.files[0]);
        });
    }

    // Drag and drop
    if (customUploadArea) {
        customUploadArea.addEventListener('dragover', (e) => {
            e.preventDefault();
            customUploadArea.classList.add('drag-over');
        });
        customUploadArea.addEventListener('dragleave', () => {
            customUploadArea.classList.remove('drag-over');
        });
        customUploadArea.addEventListener('drop', (e) => {
            e.preventDefault();
            customUploadArea.classList.remove('drag-over');
            const file = e.dataTransfer.files[0];
            if (file) handleFileSelect(file);
        });
    }

    // Remove preview
    if (removePreviewBtn) {
        removePreviewBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            selectedReferenceFile = null;
            if (customPreviewImg) customPreviewImg.src = '';
            if (customUploadPreview) customUploadPreview.style.display = 'none';
            if (customUploadPlaceholder) customUploadPlaceholder.style.display = 'flex';
            if (customReferenceImg) customReferenceImg.value = '';
            validateCustomForm();
        });
    }

    function showCustomFormError(msg) {
        if (customFormError) {
            customFormError.textContent = msg;
            customFormError.style.display = 'block';
        }
    }

    function hideCustomFormError() {
        if (customFormError) {
            customFormError.style.display = 'none';
        }
    }

    // Add to cart — uploads image then adds item
    if (customAddToCartBtn) {
        customAddToCartBtn.addEventListener('click', async () => {
            const description = customCharacterDesc ? customCharacterDesc.value.trim() : '';
            if (!description) {
                showCustomFormError('Please enter a character description.');
                return;
            }
            if (!selectedReferenceFile) {
                showCustomFormError('Please upload a reference image.');
                return;
            }

            hideCustomFormError();
            customAddToCartBtn.textContent = 'Uploading... ✨';
            customAddToCartBtn.disabled = true;

            try {
                // Read file as base64
                const imageData = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = (e) => resolve(e.target.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(selectedReferenceFile);
                });

                // Upload reference image to Netlify Blobs
                const uploadResponse = await fetch(((window.PINKLEMON && window.PINKLEMON.api_base) || '') + '/api/store-reference', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        imageData,
                        mimeType: selectedReferenceFile.type
                    })
                });

                if (!uploadResponse.ok) {
                    const err = await uploadResponse.json();
                    throw new Error(err.error || 'Failed to upload reference image.');
                }

                const { key } = await uploadResponse.json();

                // Add to cart with custom data
                addToCart(activeCustomOrder.name, activeCustomOrder.price, activeCustomOrder.image, {
                    customDescription: description,
                    customImageRef: key
                });

                closeCustomOrderModal();

                // Reset form for next order
                resetCustomOrderForm();

            } catch (err) {
                console.error('Custom order error:', err);
                showCustomFormError(err.message || 'Something went wrong. Please try again.');
                customAddToCartBtn.textContent = 'Add to Cart ✨';
                customAddToCartBtn.disabled = false;
                validateCustomForm();
            }
        });
    }

    // ============================================
    // Console Welcome Message
    // ============================================
    console.log('%c🍋 PinkLemon Crochet 🧶', 'font-size: 24px; color: #E8A0A8; font-weight: bold;');
    console.log('%cHandmade with love, one stitch at a time ♡', 'font-size: 14px; color: #A67B5B;');
    console.log('%c✨ Try the Konami code for a surprise! ✨', 'font-size: 12px; color: #FFB6C1;');
    
});

// ============================================
// Add animations for Easter egg & effects
// ============================================
const style = document.createElement('style');
style.textContent = `
    @keyframes rainbow {
        0% { filter: hue-rotate(0deg); }
        50% { filter: hue-rotate(180deg); }
        100% { filter: hue-rotate(360deg); }
    }
    
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(30px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
    
    @keyframes starSpin {
        0% { transform: rotate(0deg) scale(1); }
        50% { transform: rotate(180deg) scale(1.5); }
        100% { transform: rotate(360deg) scale(1); }
    }
`;
document.head.appendChild(style);

// ============================================
// Spotlight Slideshow
// ============================================
(function() {
    const slides = document.querySelectorAll('.spotlight-slide');
    const dots = document.querySelectorAll('.spotlight-dot');
    let currentSlide = 0;
    let timer = null;

    function ensureSlideImage(index) {
        const slide = slides[index];
        if (slide && !slide.getAttribute('src') && slide.dataset.src) {
            slide.src = slide.dataset.src;
        }
    }

    function goToSlide(n) {
        ensureSlideImage(n);
        slides.forEach(s => s.classList.remove('active'));
        dots.forEach(d => d.classList.remove('active'));
        currentSlide = n;
        if (slides[n]) slides[n].classList.add('active');
        if (dots[n]) dots[n].classList.add('active');
    }

    function advance() {
        goToSlide((currentSlide + 1) % slides.length);
    }

    if (slides.length > 0) {
        ensureSlideImage(0);
        setTimeout(() => ensureSlideImage(1), 1200);
        timer = setInterval(advance, 5500);

        dots.forEach(dot => {
            dot.addEventListener('click', function(e) {
                e.stopPropagation();
                clearInterval(timer);
                goToSlide(parseInt(this.dataset.index));
                timer = setInterval(advance, 5500);
            });
        });

        const spotlightEl = document.getElementById('spotlight');
        if (spotlightEl) {
            spotlightEl.addEventListener('click', function(e) {
                if (!e.target.classList.contains('spotlight-dot')) {
                    openPortfolio();
                }
            });
        }
    }
})();

// ============================================
// Portfolio Modal
// ============================================
function openPortfolio() {
    const modal = document.getElementById('portfolioModal');
    if (modal) {
        modal.classList.add('open');
        document.body.style.overflow = 'hidden';
    }
}

function closePortfolio() {
    const modal = document.getElementById('portfolioModal');
    if (modal) {
        modal.classList.remove('open');
        document.body.style.overflow = '';
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const closeBtn = document.getElementById('portfolioModalClose');
    if (closeBtn) closeBtn.addEventListener('click', closePortfolio);

    const modal = document.getElementById('portfolioModal');
    if (modal) {
        modal.addEventListener('click', function(e) {
            if (e.target === modal) closePortfolio();
        });
    }
});

document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closePortfolio();
});

// ============================================
// Product Image Lightbox
// ============================================
(function () {
    const overlay = document.getElementById('lightboxOverlay');
    const img = document.getElementById('lightboxImg');
    const descEl = document.getElementById('lightboxDesc');
    const closeBtn = document.getElementById('lightboxClose');
    const prevBtn = document.getElementById('lightboxPrev');
    const nextBtn = document.getElementById('lightboxNext');

    if (!overlay) return;

    let images = [];
    let currentIndex = 0;

    function openLightbox(srcs, index, description) {
        images = srcs;
        currentIndex = index;
        img.src = images[currentIndex];
        img.alt = '';
        if (descEl) {
            if (description) {
                descEl.innerHTML = description.split('||').join('<br>');
            } else {
                descEl.innerHTML = '';
            }
        }
        overlay.classList.add('open');
        document.body.style.overflow = 'hidden';
        updateNav();
    }

    function closeLightbox() {
        overlay.classList.remove('open');
        document.body.style.overflow = '';
        img.src = '';
        if (descEl) descEl.innerHTML = '';
    }

    function showImage(index) {
        currentIndex = index;
        img.src = images[currentIndex];
        updateNav();
    }

    function updateNav() {
        prevBtn.classList.toggle('hidden', images.length <= 1);
        nextBtn.classList.toggle('hidden', images.length <= 1);
    }

    closeBtn.addEventListener('click', closeLightbox);
    overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
        if (!overlay.classList.contains('open')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') showImage((currentIndex - 1 + images.length) % images.length);
        if (e.key === 'ArrowRight') showImage((currentIndex + 1) % images.length);
    });
    prevBtn.addEventListener('click', function () {
        showImage((currentIndex - 1 + images.length) % images.length);
    });
    nextBtn.addEventListener('click', function () {
        showImage((currentIndex + 1) % images.length);
    });

    // Touch swipe support inside lightbox
    let lbTouchStartX = 0;
    overlay.addEventListener('touchstart', function (e) { lbTouchStartX = e.touches[0].clientX; }, { passive: true });
    overlay.addEventListener('touchend', function (e) {
        const delta = e.changedTouches[0].clientX - lbTouchStartX;
        if (Math.abs(delta) < 50) return;
        if (delta < 0) showImage((currentIndex + 1) % images.length);
        else showImage((currentIndex - 1 + images.length) % images.length);
    }, { passive: true });

    // Click on product image to open lightbox; swipe on product card gallery
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.product-card').forEach(function (card) {
            const productImg = card.querySelector('.product-img');

            if (!productImg) return;

            // Always query live DOM so variant-button dot replacements are reflected
            function getImageSrcs() {
                const liveDots = card.querySelectorAll('.gallery-dot');
                if (liveDots.length > 0) {
                    return Array.from(liveDots).map(d => d.dataset.img);
                }
                return [productImg.src];
            }

            function currentDotIndex() {
                const liveDots = card.querySelectorAll('.gallery-dot');
                const activeDot = card.querySelector('.gallery-dot.active');
                if (!activeDot) return 0;
                return Array.from(liveDots).indexOf(activeDot);
            }

            // Open lightbox on image click
            productImg.style.cursor = 'zoom-in';
            productImg.addEventListener('click', function () {
                openLightbox(getImageSrcs(), currentDotIndex(), card.dataset.description || '');
            });

            // Mobile swipe on product card to switch gallery image
            const initialDots = card.querySelectorAll('.gallery-dot');
            if (initialDots.length > 1) {
                let touchStartX = 0;
                card.addEventListener('touchstart', function (e) {
                    touchStartX = e.touches[0].clientX;
                }, { passive: true });
                card.addEventListener('touchend', function (e) {
                    const delta = e.changedTouches[0].clientX - touchStartX;
                    if (Math.abs(delta) < 50) return;
                    const liveDots = card.querySelectorAll('.gallery-dot');
                    const idx = currentDotIndex();
                    const newIdx = delta < 0
                        ? Math.min(idx + 1, liveDots.length - 1)
                        : Math.max(idx - 1, 0);
                    if (newIdx !== idx) {
                        liveDots[newIdx].click();
                    }
                }, { passive: true });
            }
        });

        // Inspo gallery images — click to zoom in lightbox
        const galleryImgs = document.querySelectorAll('.pinterest-img img');
        const gallerySrcs = Array.from(galleryImgs).map(i => i.getAttribute('src'));
        galleryImgs.forEach(function (imgEl, idx) {
            imgEl.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                openLightbox(gallerySrcs, idx);
            });
        });
    });

    // Inspo gallery images — also wire up directly in case DOMContentLoaded already fired
    document.querySelectorAll('.pinterest-img img').forEach(function (imgEl, idx, all) {
        imgEl.style.cursor = 'zoom-in';
        imgEl.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const srcs = Array.from(all).map(i => i.getAttribute('src'));
            openLightbox(srcs, idx);
        });
    });

    // Portfolio modal images — click to zoom in lightbox
    function wirePortfolioLightbox() {
        const items = document.querySelectorAll('.portfolio-item img');
        const srcs = Array.from(items).map(i => i.getAttribute('src'));
        items.forEach(function (imgEl, idx) {
            imgEl.style.cursor = 'zoom-in';
            imgEl.addEventListener('click', function (e) {
                e.stopPropagation();
                openLightbox(srcs, idx);
            });
        });
    }

    // Wire immediately (images already in DOM) and also after modal opens
    wirePortfolioLightbox();
    document.addEventListener('click', function (e) {
        if (e.target && e.target.id === 'portfolioModal') return;
        // Re-wire each time the modal becomes visible in case lazy-loaded imgs changed
        const modal = document.getElementById('portfolioModal');
        if (modal && modal.classList.contains('open')) {
            wirePortfolioLightbox();
        }
    });
}());

// ============================================
// Limited-Stock Counter
// ============================================
(function () {
    document.querySelectorAll('[data-stock-product]').forEach(function (card) {
        const productKey = card.dataset.stockProduct;
        const counter = card.querySelector('.stock-counter');
        const addBtn = card.querySelector('.add-to-cart');

        fetch('/.netlify/functions/get-stock?product=' + encodeURIComponent(productKey))
            .then(function (r) { return r.json(); })
            .then(function (data) {
                // If data.stock is not a number (error response), do nothing —
                // leave the button enabled and the counter blank rather than
                // falsely showing Sold Out.
                if (typeof data.stock !== 'number') return;
                const stock = data.stock;
                if (counter) {
                    if (stock <= 0) {
                        counter.textContent = 'Sold out';
                        counter.classList.add('sold-out');
                    } else {
                        counter.textContent = 'Only ' + stock + ' left!';
                    }
                }
                if (stock <= 0 && addBtn) {
                    addBtn.disabled = true;
                    addBtn.textContent = 'Sold Out';
                    addBtn.style.opacity = '0.5';
                    addBtn.style.cursor = 'not-allowed';
                    addBtn.style.pointerEvents = 'none';
                }
            })
            .catch(function () {
                // Silently ignore — stock badge just stays blank
            });
    });
}());



// --- Shopify availability ---------------------------------------------------
// Reflect real Shopify inventory on the product cards (replaces the old
// Netlify Blobs stock check).
document.addEventListener('DOMContentLoaded', function () {
    if (!window.PINKLEMON || !window.PINKLEMON.products) return;
    document.querySelectorAll('.product-card[data-shopify-handle]').forEach(function (card) {
        const entry = window.PINKLEMON.products.find(p => p.handle === card.dataset.shopifyHandle);
        if (!entry || !entry.variants) return;
        const anyAvailable = Object.keys(entry.variants).some(k => entry.variants[k].available !== false);
        if (anyAvailable) return;
        card.classList.add('sold-out');
        const btn = card.querySelector('.add-to-cart');
        if (btn) { btn.disabled = true; btn.textContent = 'Sold Out'; }
    });
});


// --- Custom orders on Shopify ----------------------------------------------
(function () {
    document.addEventListener('DOMContentLoaded', function () {
        const btn = document.getElementById('customAddToCartBtn');
        const descEl = document.getElementById('customCharacterDesc');
        const fileEl = document.getElementById('customReferenceImg');
        const titleEl = document.getElementById('customOrderModalTitle');
        const errEl = document.getElementById('customFormError');
        if (!btn || !descEl || !fileEl || !titleEl || !window.PINKLEMON) return;

        function fail(msg) {
            if (errEl) { errEl.textContent = msg; errEl.style.display = 'block'; }
            btn.textContent = 'Add to Cart ✨';
            btn.disabled = false;
        }

        function variantForName(name) {
            const entry = window.PINKLEMON.products.find(p => p.name === name);
            if (!entry || !entry.variants) return null;
            const keys = Object.keys(entry.variants);
            return keys.length ? entry.variants[keys[0]] : null;
        }

        // Capture phase so this runs instead of the original Netlify handler.
        btn.addEventListener('click', async function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            const description = (descEl.value || '').trim();
            const file = fileEl.files && fileEl.files[0];
            if (!description) return fail('Please describe the character you would like.');
            if (!file) return fail('Please upload a reference image.');

            const name = (titleEl.textContent || '').trim();
            const variant = variantForName(name);
            if (!variant || !variant.id) {
                return fail('This custom order is not available right now. Please message me on Instagram.');
            }

            btn.textContent = 'Adding... ✨';
            btn.disabled = true;

            try {
                // Move any items already in the on-page cart into Shopify's cart
                // first, so a custom order can be combined with ready-made items.
                let existing = [];
                try { existing = JSON.parse(localStorage.getItem('pinklemonCart')) || []; } catch (_) { existing = []; }

                await fetch(window.PINKLEMON.routes.cart_clear, {
                    method: 'POST', headers: { 'Content-Type': 'application/json' }
                });

                const lines = [];
                existing.forEach(function (item) {
                    const entry = window.PINKLEMON.products.find(p => p.name === item.name);
                    if (!entry || !entry.variants) return;
                    const v = (item.variant && entry.variants[item.variant])
                        || entry.variants[Object.keys(entry.variants)[0]];
                    if (!v || !v.id || v.available === false) return;
                    const props = {};
                    if (item.customDescription) props['Your description'] = item.customDescription;
                    lines.push({ id: v.id, quantity: item.quantity, properties: props });
                });

                if (lines.length) {
                    const res = await fetch(window.PINKLEMON.routes.cart_add, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                        body: JSON.stringify({ items: lines })
                    });
                    if (!res.ok) throw new Error('Could not move your cart over. Please try again.');
                }

                // Now the custom line, as a real form POST so the file uploads.
                const form = document.createElement('form');
                form.action = '/cart/add';
                form.method = 'post';
                form.enctype = 'multipart/form-data';
                form.style.display = 'none';

                const hidden = function (n, v) {
                    const i = document.createElement('input');
                    i.type = 'hidden'; i.name = n; i.value = v;
                    form.appendChild(i);
                };
                hidden('id', variant.id);
                hidden('quantity', '1');
                hidden('properties[Your description]', description);
                hidden('properties[Terms]', 'Custom order — made to order, not returnable or refundable once purchased.');
                hidden('return_to', '/cart');

                // Carry the chosen file across into the form's own input.
                const upload = document.createElement('input');
                upload.type = 'file';
                upload.name = 'properties[Reference image]';
                let transferred = false;
                try {
                    const dt = new DataTransfer();
                    dt.items.add(file);
                    upload.files = dt.files;
                    transferred = upload.files.length === 1;
                } catch (_) { transferred = false; }

                if (transferred) {
                    form.appendChild(upload);
                } else {
                    // Older browsers: reuse the original input element itself.
                    fileEl.setAttribute('name', 'properties[Reference image]');
                    form.appendChild(fileEl);
                }

                // The on-page cart has been handed over to Shopify.
                localStorage.removeItem('pinklemonCart');

                document.body.appendChild(form);
                form.submit();
            } catch (err) {
                console.error('Custom order error:', err);
                fail(err.message || 'Something went wrong. Please try again.');
            }
        }, true);
    });
})();
